import { ModalRef } from '@agentifai/core-ui/modal';
import { Component } from '@angular/core';

@Component({
    selector: 'ag-dashboard-confirmation-window',
    templateUrl: './confirmation-window.component.html',
    styleUrls: ['./confirmation-window.component.scss'],
})
export class ConfirmationWindowComponent {
    config: { [key: string]: any };

    constructor(public data: ModalRef) {
        this.config = data.data;
    }

    proceed(): void {
        this.config.responseSubject.next(true);
    }

    reject(): void {
        this.config.responseSubject.next(false);
    }
}
